import styled from 'styled-components';
import * as SelectPrimitive from '@radix-ui/react-select';

export const StyledTrigger = styled(SelectPrimitive.Trigger)<{ $width?: number; $withIcon?: boolean }>`
    display: inline-flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    border: none;
    width: auto;
    border-radius: 12px;
    height: 40px;
    box-sizing: border-box;
    padding: ${props => `8px ${props.$withIcon ? 44 : 12}px 8px 12px`};
    background-color: ${props => props.theme.root.colors.basicColors['10%']};
    color: ${props => props.theme.root.input.root.color};

    &:hover,
    &:focus {
        background-color: ${props => props.theme.root.colors.basicColors['15%']};
    }

    &:active {
        background-color: ${props => props.theme.root.colors.basicColors['10%']};
    }

    &:disabled {
        background-color: ${props => props.theme.root.colors.basicColors['4%']};
    }
`;

export const StyledContent = styled(SelectPrimitive.Content)<{ $height?: number }>`
    border-radius: 12px;
    background: ${props => props.theme.root.colors.background['02Second']};
    height: ${props => (props.$height ? `${props.$height}px` : 'auto')};
    overflow: hidden;
    min-width: var(--radix-select-trigger-width);
    max-height: var(--radix-select-content-available-height);
    z-index: 10000;
`;
export const StyledViewport = styled(SelectPrimitive.Viewport)`
    overflow-y: auto;
    scrollbar-width: thin !important;
    scrollbar-color: ${props => props.theme.root.colors.basicColors['10%']} transparent;
`;
export const StyledItem = styled(SelectPrimitive.Item)`
    box-sizing: border-box;
    padding: 8px 16px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
    color: ${props => props.theme.root.colors.basicColors['90%']};
    &:hover,
    &:focus {
        background-color: ${props => props.theme.root.colors.basicColors['15%']};
    }

    &[data-state='checked'] {
        background-color: ${props => props.theme.root.colors.basicColors['20%']};
    }

    &[data-disabled] {
        background-color: ${props => props.theme.root.colors.basicColors['4%']};
        color: ${props => props.theme.root.colors.basicColors['25%']};
    }
`;
export const StyledIcon = styled(SelectPrimitive.Icon)``;
